<ng-container *ngIf="values; else noValues">
  <ng-container [ngSwitch]="values.length">
    <ng-container *ngSwitchCase="0">
      <mat-label translate>select.service.label.none</mat-label>
    </ng-container> 
    <ng-container *ngSwitchCase="1">
      <mat-form-field class="def-select single-element-select" appearance="outline" floatLabel="always" >
        <mat-label translate>select.service.label.single</mat-label>
        <mat-select   (selectionChange)   = "onChange($event)"
                      [(ngModel)]         = "currentValue" disabled>
          <mat-option [value]="value" 
                      *ngFor="let value of values">
            {{ value.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <mat-form-field class="def-select" appearance="outline" floatLabel="always" >
        <mat-label translate>select.service.label.multiple</mat-label>
        <mat-select   (selectionChange)   = "onChange($event)"
                      [(ngModel)]         = "currentValue">
          <mat-option *ngIf   = "all"
                      [value] = "all" >
            {{ 'all?.name' | translate }}
          </mat-option>

          <mat-option [value]="value" 
                      *ngFor="let value of values">
            {{ value.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #noValues>
  <!-- handle no data loaded due to error -->
</ng-template>
